import { render, staticRenderFns } from "./ProductSalesContractPrint.vue?vue&type=template&id=be2fafc4&scoped=true&"
import script from "./ProductSalesContractPrint.vue?vue&type=script&lang=js&"
export * from "./ProductSalesContractPrint.vue?vue&type=script&lang=js&"
import style0 from "./ProductSalesContractPrint.vue?vue&type=style&index=0&id=be2fafc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be2fafc4",
  null
  
)

export default component.exports